import { atom } from "jotai";

export const zoomFrontAtom = atom(2);

export const zoomBackAtom = atom(2);

export const panFrontAtom = atom({ x: 0, y: 0 });

export const panBackAtom = atom({ x: 0, y: 0 });

export const isTwoFingerGestureAtom = atom(false);

// Synchronous ref-based gesture tracking (for immediate checks in event handlers)
// Used to prevent pin placement during/after drag or pinch gestures
export const gestureStateRef = {
  isGestureActive: false,
  hasMoved: false,
  gestureJustEnded: false
};
